<template>
  <div id="contact">
    <NavBar />

    <div id="hero" class="hero overlay subpage-hero">
      <div class="hero-content">
        <div class="hero-text">
          <h1>联系我们</h1>
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link to="/">首页</router-link>
            </li>
            <li class="breadcrumb-item active">联系我们</li>
          </ol>
        </div>
        <!-- /.hero-text -->
      </div>
      <!-- /.hero-content -->
    </div>
    <!-- /.hero -->

    <main id="main" class="site-main">
      <section class="site-section subpage-site-section section-contact-us">
        <div class="container">
          <div class="row">
            <div class="col-sm-7">
              <h2>发送信息</h2>
              <div id="success"></div>
              <form name="sentMessage" id="contactForm" novalidate="novalidate">
                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group control-group">
                      <label for="name">名字:</label>
                      <input
                        type="text"
                        class="form-control"
                        id="name"
                        placeholder="名字.."
                        required="required"
                        data-validation-required-message="请输入你的名字"
                      />
                      <p class="help-block text-danger"></p>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group control-group">
                      <label for="email">电子邮件:</label>
                      <input
                        type="email"
                        class="form-control"
                        id="email"
                        placeholder="电子邮件.."
                        required="required"
                        data-validation-required-message="请输入你的电子邮件"
                      />
                      <p class="help-block text-danger"></p>
                    </div>
                  </div>
                </div>
                <div class="form-group control-group">
                  <label for="message">标题:</label>
                  <input
                    class="form-control"
                    id="subject"
                    placeholder="标题.."
                    required="required"
                    data-validation-required-message="请输入你的标题"
                  />
                  <p class="help-block text-danger"></p>
                </div>
                <div class="form-group control-group">
                  <label for="message">信息:</label>
                  <textarea
                    class="form-control form-control-comment"
                    id="message"
                    placeholder="信息.."
                    required="required"
                    data-validation-required-message="请输入你的信息"
                  ></textarea>
                  <p class="help-block text-danger"></p>
                </div>
                <div class="text-center">
                  <button
                    id="sendMessageButton"
                    type="submit"
                    class="btn btn-green"
                  >
                    发送
                  </button>
                </div>
              </form>
            </div>
            <div class="col-sm-5">
              <div class="contact-info">
                <h2>联系方式</h2>
                <div class="row">
                  <div class="col-sm-12">
                    <h3>地址</h3>
                    <ul class="list-unstyled">
                      <li>
                        71 & 73, Jalan Hujan Emas 8, Taman Overseas Union, 58200
                        Kuala Lumpur, Wilayah Persekutuan Kuala Lumpur
                      </li>
                    </ul>
                    <h3>电子邮件</h3>
                    <a href="mailto:zgkmsb@gmail.com" target="_blank"
                      >zgkmsb@gmail.com</a
                    >
                    <h3>公司电话号码</h3>
                    <a href="tel:+60379838560" target="_blank"
                      >+603-7983 8560</a
                    >
                    <h3>手机电话号码</h3>
                    <a href="https://wa.me/60162822252" target="_blank"
                      >+6016-282 2252</a
                    >
                  </div>
                </div>
              </div>
              <!-- /.contact-info -->
            </div>
          </div>
        </div>
      </section>
      <!-- /.section-contact-us -->
      <div class="maps-container">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15936.362494303374!2d101.6763847!3d3.0704572!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x7600c838f0c1286e!2z6K-46JGb5a2U5piO5pyJ6ZmQ5YWs5Y-4IFpodSBHZSBLb25nIE1pbmcgU0ROLiBCSEQu!5e0!3m2!1sen!2smy!4v1657879187539!5m2!1sen!2smy"
          width="100%"
          height="450"
          style="border:0;"
          allowfullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
      <!-- /.section-map -->
    </main>
    <!-- /#main -->

    <Footer />
  </div>
</template>

<script>
/* eslint-disable */
import NavBar from "./partials/NavBar.vue";
import Footer from "./partials/Footer.vue";

export default {
  name: "ContactIndex",
  data() {
    return {};
  },
  components: {
    NavBar,
    Footer
  },
  created() {
    $(function() {
      $("#contactForm input, #contactForm textarea").jqBootstrapValidation({
        preventSubmit: true,
        submitError: function($form, event, errors) {},
        submitSuccess: function($form, event) {
          event.preventDefault();
          var name = $("input#name").val();
          var email = $("input#email").val();
          var subject = $("input#subject").val();
          var message = $("textarea#message").val();

          var sendBtn = $("#sendMessageButton");
          sendBtn.prop("disabled", true);

          $.ajax({
            url: "contact.php",
            type: "POST",
            data: {
              name: name,
              email: email,
              subject: subject,
              message: message
            },
            cache: false,
            success: function() {
              $("#success").html("<div class='alert alert-success'>");
              $("#success > .alert-success")
                .html(
                  "<button type='button' class='close' data-dismiss='alert' aria-hidden='true'>&times;"
                )
                .append("</button>");
              $("#success > .alert-success").append(
                "<strong>你的信息已成功发送。</strong>"
              );
              $("#success > .alert-success").append("</div>");
              $("#contactForm").trigger("reset");
            },
            error: function() {
              // $('#success').html("<div class='alert alert-danger'>");
              // $('#success > .alert-danger').html("<button type='button' class='close' data-dismiss='alert' aria-hidden='true'>&times;")
              //         .append("</button>");
              // $('#success > .alert-danger').append($("<strong>").text("Sorry " + name + ", it seems that our mail server is not responding. Please try again later!"));
              // $('#success > .alert-danger').append('</div>');
              // $('#contactForm').trigger("reset");
            },
            complete: function() {
              setTimeout(function() {
                sendBtn.prop("disabled", false);
              }, 1000);
            }
          });
        },
        filter: function() {
          return $(this).is(":visible");
        }
      });

      $('a[data-toggle="tab"]').click(function(e) {
        e.preventDefault();
        $(this).tab("show");
      });
    });

    $("#name").focus(function() {
      $("#success").html("");
    });
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Contact.vue